import { OpenAPI, RequestersService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT
export async function getRequesterSearch(fullName: string, opco: string) {
  let data = RequestersService.searchRequestersRequestersSearchGet(fullName, opco)

  return data
}
